<template>
	<div id="PageHomeGrav"  class="wrapper-fluid content-home">
		<Navigation />

		<div class="wrapper-slider">
			<div class="container-fluid wrapper-slider-txt">
				<div class="row">
					<div class="col col-sm-10 offset-sm-1 col-md-9 offset-md-2 col-lg-7 offset-lg-5  wrapper-rounded-content">
						<div class="bg-blue-multiply rounded-corners"></div>
						<div class="row">
							<div class="col-lg-12">
								<h3>{{ $t("Bleib in Bewegung!") }}</h3>
								<h4>{{ $t("kurzfristig, stundenweise, mobil, mieten") }}</h4>
							</div>
						</div>
						<div class="row">
							<div class="col col-xs-6 align-self-center">
								<p class="med">schon ab</p>
							</div>
							<div class="col col-xs-6">
								<p class="large">9,00€</p>
							</div>
							<div class="col col-sm-4 align-self-center">
								<router-link :to="{name: 'PageRegister'}"><p class="mit-button">{{ $t("JETZT REGISTRIEREN") }}</p></router-link>
							</div>
						</div>
						<div class="row">
							<div class="col-lg-12">
								<div class="teaser-rund">
									<p>Ohne<br>Anmelde-<br>gebühr!</p>
								</div>
							</div>
						</div>

					</div>
				</div>
			</div>
			<div class="wrapper-img">
				<img class="img-fluid" src="/static/img/slider-pic02.jpg">
			</div>
		</div>


		<div class="container wrapper-white-with-phone">
			<div class="row">
				<div class="col-lg-6 col-xl-7">
					<h2>Wie funktioniert C-Share?</h2>
					<h1>Autos mal einfach mieten!</h1>
					<p>C-Share fängt genau da an wo die normale Autovermietung aufhört, nämlich direkt am Auto. Mit der C-Share App kannst Du einfach ein Auto mieten und losfahren. Und das jederzeit. Tag und Nacht. Ohne Büro und umständliche Formulare. Einfach mit der C-Share App die nächste Station ermitteln oder den Standort eines gewünschten Fahrzeugs wie Cabrio für den Ausflug oder Kombi für den IKEA Einkauf ermitteln, buchen und vor Ort einfach losfahren. Registrieren und auf gehts!</p>
					<div class="wrapper-btn-center">
						<router-link :to="{name: 'PagePlace'}">
							<button type="button" class="btn btn-primary btn-wp">{{ $t('Book now')}}</button>
						</router-link>
					</div>
				</div>
				<div class="col-lg-5 offset-lg-1 col-xl-4 offset-xl-1 text-center">
					<img src="/static/img/iphone.png">
					<div class="teaser-rund">
						<p>Ohne<br>Anmelde-<br>gebühr!</p>
					</div>
				</div>
			</div>
		</div>

		<StationsHero></StationsHero>

		<div class="container-fluid wrapper-footer bg-blue-diagonal">
			<div class="row justify-content-center">
				<div class="col-lg-6 text-center">
					<h2>{{ $t('Book here and get started with the app:') }}</h2>
					<router-link :to="{name: 'PagePlace'}">
						<button type="button" class="btn btn-secondary btn-wp">{{ $t('Start reservation')}}</button>
					</router-link>
				</div>
			</div>
		</div>

		<router-view />

		<Footer></Footer>
	</div>
</template>

<script>
export default {
	name: 'PageHomeGrav'
}
</script>





// WEBPACK FOOTER //
// src/components/Pages/PageHomeGrav.vue